export const REQUIRED_TDATA_FILES = ["key_datas", "D877F783D5D3EF8Cs"] as const
export const MAX_TDATA_FILES = 20

/**
 * Валидация массива файлов tdata для one-shot импорта (POST /clients/tdata-import).
 * Обязательные имена: key_datas + D877F783D5D3EF8Cs (с учётом регистра).
 * Остальные файлы игнорируются бэком — передаём весь корень tdata.
 */
export function validateTdataFiles(files: File[]): string | null {
  if (files.length > MAX_TDATA_FILES) {
    return `Не более ${MAX_TDATA_FILES} файлов`
  }
  const names = new Set(files.map((f) => f.name))
  const missing = REQUIRED_TDATA_FILES.filter((n) => !names.has(n))
  if (missing.length > 0) {
    return `Отсутствуют обязательные файлы tdata: ${missing.join(", ")}`
  }
  return null
}
